// Item templates from before the MVP catalog (CHANGELOG 0.2.0). Saved items that
// still carry one of these ids are moved to the closest new item with the same
// slot and a similar tier; rarity, item level, affixes and passive stay.

export const LEGACY_ITEM_IDS: Record<string, string> = {
  // Weapons
  service_carbine: 'r12_service_carbine',
  ember: 'r12_service_carbine',
  the_quiet_one: 'stalker_crossbow',
  // Helmets
  moto_helmet: 'bucket_helm',
  gas_mask_hood: 'headlamp_cap',
  riot_helmet: 'headlamp_cap',
  eye_of_the_storm: 'combat_helmet',
  // Body
  leather_rider_jacket: 'road_sign_vest',
  hazmat_top: 'paramedic_jacket',
  kevlar_vest: 'paramedic_jacket',
  vaultguard: 'plate_carrier',
  // Boots
  work_boots: 'steel_toe_boots',
  hiking_boots: 'tread_boots',
  firefighter_boots: 'paramedic_boots',
  tactical_boots: 'paramedic_boots',
  ghost_walkers: 'soft_sole_boots',
  // Gloves
  insulated_gloves: 'nitrile_gloves',
  // Backpacks
  nomads_burden: 'military_rucksack',
};

/**
 * Old ids that came back as new catalog items in krug 5 (F10: the Rider and Hunter sets).
 * The 0.2 migration moved every old item with these ids long ago, so today they mean the
 * new items; only that migration still reads them through LEGACY_ITEM_IDS.
 */
export const REUSED_ITEM_IDS: ReadonlySet<string> = new Set(['moto_helmet', 'leather_rider_jacket', 'hiking_boots']);

/** The current template id for a saved id (unchanged when it is not a legacy id). */
export function currentItemId(id: string): string {
  if (REUSED_ITEM_IDS.has(id)) return id;
  return LEGACY_ITEM_IDS[id] ?? id;
}
